"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuerySource = void 0;
/**
 * The source of the search request.
 *
 * @public
 */
var QuerySource;
(function (QuerySource) {
    /**
     * Indicates that the query was initiated from a standard Answers integration.
     */
    QuerySource["Standard"] = "STANDARD";
    /**
     * Indicates that the query was initaited from an Answers Overlay.
     */
    QuerySource["Overlay"] = "OVERLAY";
})(QuerySource = exports.QuerySource || (exports.QuerySource = {}));
